import { DBMSType } from '@/enums';
import { DBMSTypesDTO, DBMSTypeSelect } from '../types';
import { sortBy } from '@prometheus/utils';

// TODO 17-11-2022

export const parseDbmsTypesForSelectForm = (
  list: DBMSTypesDTO
): DBMSTypeSelect[] => {
  const listSelect = Object.keys(list).map((itemId: DBMSType) => {
    return {
      name: list[itemId]?.label || itemId,
      value: itemId,
    };
  });
  return sortBy(listSelect, elem => elem.name);
};
